/**
 * @generated SignedSource<<0e0875774e860e04b8dfb07501d6a2d4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item" | "PdpSharedSocialShareEmail_item" | "PdpSharedSocialShareFacebook_item" | "PdpSharedSocialSharePinterest_item">;
  readonly " $fragmentType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$key = {
  readonly " $data"?: PdpRespIconBubbles_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialSharePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1f0b1c0d0d462ae76955a7721edc19d5";

export default node;
